<template>
  <div class="single-banner-container" v-if="cellList.length > 0" :style="getColor">
    <SingleBannerItem :bannerInfo="cellList[0]"></SingleBannerItem>
  </div>
</template>

<script>
import { get } from 'lodash'
import SingleBannerItem from './banner/SingleBannerItem'
import { EventService } from '@/common/api/api.service'
import EventModelClass from '@/common/model/EventModelClass'
export default {
  name: 'Banner2',
  props: ['sectionInfo'],
  data () {
    return {
      bannerInfo: null,
      bannerBackgroundColor: '',
      cellList: []
    }
  },
  components: {
    SingleBannerItem: SingleBannerItem
  },
  computed: {
    getColor () {
      return `background-color: ${this.bannerBackgroundColor}`
    }
  },
  created () {
    EventService.requestEventData(new EventModelClass(this.sectionInfo.contentEvent)).then((response) => {
      this.bannerBackgroundColor = get(response, ['data', 'note'], '')
      this.cellList = response.data.band.celllist.map((cell) => {
        return cell
      })
    })
  }
}
</script>

<style scoped>
  .single-banner-container {
    width: 100%;
    margin: 10px 0;
  }
</style>
